module.exports = __webpack_public_path__ + "img/qr-youzan.29ddda6c.png";